import type { SkillListItem } from '../../lib/api-client';

interface Props {
  skills: SkillListItem[];
  selectedId: string | null;
  onSelect: (id: string) => void;
}

export function SkillList({ skills, selectedId, onSelect }: Props) {
  return (
    <div>
      {skills.map((s) => {
        const isSelected = s.id === selectedId;
        return (
          <button
            key={s.id}
            type="button"
            onClick={() => onSelect(s.id)}
            aria-current={isSelected ? 'true' : undefined}
            style={{
              width: '100%',
              padding: '10px 14px',
              border: 0,
              borderBottom: '1px solid var(--border)',
              background: isSelected ? 'var(--bg-alt2, var(--bg-alt))' : 'transparent',
              color: 'var(--text)',
              cursor: 'pointer',
              fontFamily: 'inherit',
              textAlign: 'left',
              display: 'flex',
              flexDirection: 'column',
              gap: 4,
            }}
          >
            <span
              style={{
                fontSize: 13,
                fontWeight: 600,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
              }}
            >
              {s.name}
            </span>
            <span
              style={{
                fontSize: 11,
                color: 'var(--text-soft)',
                lineHeight: 1.4,
                display: '-webkit-box',
                WebkitLineClamp: 2,
                WebkitBoxOrient: 'vertical',
                overflow: 'hidden',
              }}
            >
              {s.description || 'No description.'}
            </span>
          </button>
        );
      })}
    </div>
  );
}
